const words = {
  spanish: [
    {
      title: "Restaurante",
      description:
        "Disfrute de su comida mientras exalta todos sus sentidos en este hermoso valle, apreciando la belleza paisajística del lugar con su majestuosa Palma de cera matizada con la gran gama de verdes de sus montañas.",
      img: "./images/FrenteRestaurante.jpeg",
      path: "/restaurant",
    },
    {
      title: "Hospedaje",
      description:
        "Viva una experiencia de paz, tranquilidad y armonía que le ofrece las palmas de cocora en su cabaña construida en madera rodeada de coloridas flores y palmas de cera. ¡El lugar perfecto para una escapada de un fin de semana!",
      img: "./images/Cabin.jpeg",
      path: "/lodging",
    },
    {
      title: "Glamping",
      description:
        "Este es el lugar perfecto para esas escapadas de un fin de semana en pareja, para sacarse el peso de la ciudad y disfrutar de una experiencia única dentro de las montañas del Valle de Cocora.",
      img: "./images/glamping21.jpeg",
      path: "/cocora-nidos-del-condor",
    },
    {
      title: "Camping",
      description:
        "El Eco-Hotel Las Palmas de Cocora cuenta con un amplio espacio verde bajo un cielo descubierto que, al anochecer, se ilumina con la luz de las estrellas y constelaciones. Una experiencia única para los amantes de la naturaleza.",
      img: "./images/CampingZone.jpeg",
      path: "/camping",
    },
    {
      title: "Casita del sabor",
      description:
        "Déjese atrapar por el aroma del café, disfrute de esta deliciosa bebida preparada en diferentes formas, en nuestra casita de arquitectura quindiana.",
      img: "./images/CasitaDelSabor.jpeg",
      path: "/cofee-house",
    },
    {
      title: "Vivero Cocora Viva",
      description:
        "Venga y aproveche la oportunidad de llevarse con usted un recuerdo de la flora del Valle, con el toque único del Vivero Cocora Viva",
      img: "./images/vivero1.jpeg",
      path: "/cocora-viva",
    },
    {
      title: "Paseos Ecológicos",
      description:
        "Una cabalgata por el Valle de Cocora en Salento Quindío es la experiencia que no puede faltar en la agenda de vacaciones.",
      img: "./images/valle-de-cocora-g982a52cf0_1920.jpg",
      path: "/horseback-riding",
    },
    // {
    //   title: "Artesanías",
    //   description:
    //     "Visite nuestro almacén de artesanía con productos exclusivos fabricados por artesanos de Salento donde podrá adquirir un lindo souvenir para llevar de recuerdo.",
    //   img: "./images/artesanias.jpeg",
    //   path: "/regional-crafts",
    // },
    {
      title: "Atracciones",
      description:
        "Contamos con una zona adaptada para los niños, para que los más chicos puedan divertirse, mientras los más grandes disfrutan de los servicios del Restaurante.",
      img: "./images/Atracciones.jpeg",
      path: "/games",
    },
  ],
  english: [
    {
      title: "Restaurant",
      description:
        "Allow yourself to awaken all of your senses in this beautiful Valley, while admiring the beauty of the land with its majestic wax palm trees and its green mountains.",
      img: "./images/FrenteRestaurante.jpeg",
      path: "/restaurant",
    },
    {
      title: "Lodging",
      description:
        "Let yourself experience the peace, tranquility and harmony that the restaurant Las Palmas offers you with its wooden cabin in the middle of colourful flowers and wax palm trees. The perfect place for a weekend breakaway!",
      img: "./images/Cabin.jpeg",
      path: "/lodging",
    },
    {
      title: "Glamping",
      description:
        "This is the perfect place for those one weekend couple runaways, take this chance to take the city's weight of your shoulders and enjoy of this unique experience deep inside the Valley's mountains.",
      img: "./images/glamping21.jpeg",
      path: "/cocora-nidos-del-condor",
    },
    {
      title: "Camping",
      description:
        "The Eco-Hotel Las Palmas de Cocora has a large green space, under the light of the night sky filled with stars and constellations for you to admire. A once in a lifetime experience for those nature lovers.",
      img: "./images/CampingZone.jpeg",
      path: "/camping",
    },
    {
      title: "Coffee House",
      description:
        "Let yourself be infected with the aroma of coffee, enjoy this delicious beverage in all of its different forms in our little house of regional architecture.",
      img: "./images/CasitaDelSabor.jpeg",
      path: "/cofee-house",
    },
    {
      title: "Florist Cocora Viva",
      description:
        "Comme and take advantage of this opportunity to bring back home a memory with the special touch of the Florist Cocora Viva",
      img: "./images/vivero1.jpeg",
      path: "/cocora-viva",
    },
    {
      title: "Eco-friendly Activities",
      description:
        "A Horseback Ride inside the Cocora Valley at Salento, Quindio is an experience you cannot miss on your agenda.",
      img: "./images/valle-de-cocora-g982a52cf0_1920.jpg",
      path: "/horseback-riding",
    },
    // {
    //   title: "Regional Crafts",
    //   description:
    //     "Come visit our craft store, we have exclusive products handmade by Salento's craftsmen, here you can buy a nice souvenir so you can bring a part of the Valley with you!",
    //   img: "./images/artesanias.jpeg",
    //   path: "/regional-crafts",
    // },
    {
      title: "Games",
      description:
        "We have a special zone for the kids, so that the little ones can have fun while the grownups enjoy of the restaurant services.",
      img: "./images/Atracciones.jpeg",
      path: "/games",
    },
  ],
};

export default words;
